import { createFileRoute } from "@tanstack/react-router";
import Platform from "../components/tk/pages/Platform";

const title = "Restaurant management platform and pricing | thatKorner";
const description = "Orders, tables, kitchen tickets, QR menus, billing and payments with menu intelligence on top. From USD 149 per outlet a month, with a 15-day trial and no card.";

export const Route = createFileRoute("/platform")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.thatkorner.com/platform" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.thatkorner.com/platform" }],
  }),
  component: Platform,
});
